export default __webpack_public_path__ + "assets/2cc7a6f81dd88a09b3d357b16a74c968.woff";